import { render, staticRenderFns } from "./jobTab1.vue?vue&type=template&id=c673c138&scoped=true&"
import script from "./jobTab1.vue?vue&type=script&lang=js&"
export * from "./jobTab1.vue?vue&type=script&lang=js&"
import style0 from "./jobTab1.vue?vue&type=style&index=0&id=c673c138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c673c138",
  null
  
)

export default component.exports